console.log("contact_form_validation loaded"),
    window.addEventListener("load", function () {
        let t = document.getElementById("60796-textarea"),
            e = document.querySelector("#globo-formbuilder-60796 > div > div > div > form > div.globo-formbuilder-wizard > div > div.gfb__footer.wizard__footer > button.action.next.submit.material_outlined-button.wizard__submit"),
            o = [
                "guestpost",
                "linkbuild",
                "backlink",
                "outreach",
                "blogger",
                "blogging",
                "highda",
                "dofollow",
                "google",
                "ranked",
                "domainauthority",
                "contentwriter",
                "ranking",
                "contentwrit",
                "blogartic",
                "guestblog",
                "digitalmarketing",
                "contentcreation",
                "seooptimization",
                "seoservice",
                "monthlyvisitor",
                "payment",
                "postlink",
                "article",
            ];
        t.addEventListener("input", function () {
            let i = t.value.toLowerCase().replaceAll(" ", "").replaceAll("-", "");
            for (let l of o)
                if (i.includes(l)) {
                    (e.disabled = !0), console.log("form button disabled");
                    return;
                }
            e.disabled = !1;
        });
    });
